module.exports = __webpack_public_path__ + "static/img/space.6e264da4.png";